import * as React from "react";
const SvgVerticalShades = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 19V3H4v16H2v2h20v-2h-2zm-10 0V5h4v14h-4z",
  fill: "currentColor"
}));
export default SvgVerticalShades;